import * as React from "react";

// @mui material components
import Grid from "@mui/material/Grid";
import { isEmpty } from "../../../components/Utils/common";

import MDInput from "../../../components/MDInput";
import PropTypes from "prop-types";
import { FormControl, FormHelperText, InputLabel, Select } from "@mui/material";
import MenuItem from "@mui/material/MenuItem";
import { useEffect, useMemo, useState } from "react";
import { useFormContext } from "react-hook-form";
import { Controller } from "react-hook-form";
import useAllowOnlyNumber from "../../../hooks/useAllowOnlyNumber";

function MerchantOfficeDetails({ merchant, editmode, setMerchant, type, mccList }) {
  const handleKeyDown = useAllowOnlyNumber();
  const {
    register,
    formState: { errors },
    control,
  } = useFormContext();
  
  // console.log("ref: ", merchant?.merchant?.referenceId);
  return (
    <Grid mt={3} mb={3} padding={2}>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={3}>
          <MDInput
            type="text"
            label="Business Name"
            name="name"
            error={errors.name}
            helperText={errors.name ? errors.name.message : ""}
            disabled={!editmode}
            fullWidth
            required
            {...register("name")}
          />
        </Grid>
        <Grid item xs={3}>
          <MDInput
            type="text"
            label="Counter ID"
            name="counterId"
            {...register("counterId")}
            error={errors.counterId}
            helperText={errors.counterId ? errors.counterId.message : ""}
            fullWidth
            disabled={!editmode}
            required
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={3}>
          <MDInput
            type="text"
            label="Vendor ID"
            name="vendorId"
            {...register("vendorId")}
            error={errors.vendorId}
            helperText={errors.vendorId ? errors.vendorId.message : ""}
            fullWidth
            disabled={!editmode}
            required
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={3}>
          <MDInput
            type="email"
            label="Email"
            name="email1"
            {...register("email1")}
            error={errors.email1}
            helperText={errors.email1 ? errors.email1.message : ""}
            fullWidth
            required
            disabled={!editmode}
          />
        </Grid>
        <Grid item xs={3}>
          <Controller
            name="mccCode"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <MDInput
                select
                {...field}
                value={field.value || ""}
                label="MCC Code"
                fullWidth
                error={!!errors.mccCode}
                className="internal-select"
                helperText={errors.mccCode ? errors.mccCode.message : ""}
                disabled={!editmode}
                sx={{ 
                  '& .MuiInputBase-root' : {
                    height: '44px'
                  }
                 }}
              >
                <MenuItem value="">-Select MCC Code-</MenuItem>
                {mccList && mccList.map((item, key) => (
                  <MenuItem key={key} value={item?.mccCode}>
                    {item?.mccCode} - {item?.description}
                  </MenuItem>
                ))}
              </MDInput>
            )}
          />
        </Grid>
        <Grid item xs={3}>
          <MDInput
            type="text"
            label="First Name"
            name="firstName"
            {...register("firstName")}
            error={errors.firstName}
            helperText={errors.firstName ? errors.firstName.message : ""}
            fullWidth
            disabled={!editmode}
          />
        </Grid>
        <Grid item xs={3}>
          <MDInput
            type="text"
            label="Last Name"
            name="lastName"
            {...register("lastName")}
            error={errors.lastName}
            helperText={errors.lastName ? errors.lastName.message : ""}
            fullWidth
            disabled={!editmode}
          />
        </Grid>
        <Grid item xs={3}>
          <MDInput
            type="text"
            label="Address"
            name="address"
            {...register("address")}
            error={errors.address}
            helperText={errors.address ? errors.address.message : ""}
            fullWidth
            disabled={!editmode}
          />
        </Grid>
        <Grid item xs={3}>
          <MDInput
            type="text"
            label="City"
            name="city"
            {...register("city")}
            error={errors.city}
            helperText={errors.city ? errors.city.message : ""}
            fullWidth
            disabled={!editmode}
          />
        </Grid>
        <Grid item xs={3}>
          <MDInput
            type="text"
            label="State"
            name="state"
            {...register("state")}
            error={errors.state}
            helperText={errors.state ? errors.state.message : ""}
            fullWidth
            disabled={!editmode}
          />
        </Grid>
        <Grid item xs={3}>
          <MDInput
            type="text"
            label="Pincode"
            name="pincode"
            {...register("pincode")}
            error={errors.pincode}
            helperText={errors.pincode ? errors.pincode.message : ""}
            fullWidth
            disabled={!editmode}
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={3}>
          <MDInput
            type="text"
            label="Phone Number"
            name="phoneNumber"
            {...register("phoneNumber")}
            error={errors.phoneNumber}
            helperText={errors.phoneNumber ? errors.phoneNumber.message : ""}
            fullWidth
            disabled={!editmode}
            onKeyDown={handleKeyDown}
          />
        </Grid>
        <Grid item xs={3}>
          <Controller
            name="transferType"
            control={control}
            defaultValue=""
            render={({ field }) => (
              <MDInput
                select
                {...field}
                value={field.value || ""}
                label="Transfer Type"
                fullWidth
                error={!!errors.transferType}
                className="internal-select"
                helperText={errors.transferType ? errors.transferType.message : ""}
                disabled={!editmode}
                sx={{ 
                  '& .MuiInputBase-root' : {
                    height: '44px'
                  }
                 }}
              >
                <MenuItem value="">-Select Transfer Type-</MenuItem>
                <MenuItem value="SLIPS">SLIPS</MenuItem>
                <MenuItem value="CEFT">CEFT</MenuItem>
              </MDInput>
            )}
          />
        </Grid>
      </Grid>
    </Grid>
  );
}

MerchantOfficeDetails.defaultProps = {
  merchant: false,
  editmode: false,
  setMerchant: false,
  type: "update",
  errors: {},
  mccList: [],
};

MerchantOfficeDetails.propTypes = {
  merchant: PropTypes.any,
  editmode: PropTypes.bool,
  setMerchant: PropTypes.func,
  type: PropTypes.string,
  errors: PropTypes.object,
  mccList: PropTypes.array,
};

export default MerchantOfficeDetails;